import React, { useEffect } from 'react';
import Contact from '../components/Contact';

import about_us_banner from '../assets/about_us_banner.jpeg'
import jyotinay_analytics_logo from '../assets/jyotinay_analytics_logo.png'

import kushal from '../assets/Kushal.jpg'
import anchit from '../assets/Anchit.jpg'
import tanvi from '../assets/Tanvi.jpg'

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div className='mt-20 relative'>
                <div className='relative mt-[6rem]'>
                    <img
                        className='w-full h-[45vh] object-cover blur-sm'
                        src={about_us_banner}
                        alt='About Us'
                    />
                    <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
                        <p className='text-white text-3xl md:text-5xl font-bold'>
                            About Us and what we do at Jyotinay Analytics
                        </p>
                        {/* <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              From intelligent automation to predictive modeling, our AI and ML solutions help your business think smarter, act faster, and scale with precision.
            </p> */}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className='container mx-auto mt-12 px-4'>
                <div className="flex flex-col md:flex-row items-start gap-20 bg-white py-8 gap-y-16 rounded-lg">
                    <img
                        className="w-full md:w-[20vw] h-[20rem] object-cover rounded-md"
                        src={jyotinay_analytics_logo}
                        alt="About Us"
                    />

                    <div className="w-full md:w-[60%] flex flex-col justify-start text-gray-700 text-left">
                        <h1 className="text-2xl md:text-3xl font-bold text-blue-700 mb-1">Company</h1>
                        <h3 className="text-xl md:text-2xl font-semibold mb-3">Jyotinay Analytics</h3>
                        <p className="text-base md:text-lg leading-relaxed">
                            Jyotinay Analytics brings together a diverse team of data analysts and consultants in a culture of innovation and collaboration.
                            Our office environment blends professionalism with warmth, fostering trust and forward-thinking. With glowing digital dashboards,
                            transparent interfaces, and a focus on powerful insights, we empower businesses to lead with data and strategy.
                        </p>
                    </div>
                </div>

                <div className='flex flex-col gap-y-16 py-8'>
                    {/* Anchit Khanna */}
                    <div className="flex flex-col md:flex-row items-start gap-4">
                        <img
                            className="w-full md:w-[20vw] h-[20rem] object-cover rounded-md"
                            src={anchit}
                            alt="Anchit Khanna"
                        />
                        <div className="md:px-12 mt-4 md:mt-0">
                            <h1 className="text-2xl font-semibold text-left">Anchit Khanna</h1>
                            <h3 className="text-xl text-gray-600 text-left">Data Scientist & ML Engineer – Vodafone | Cheif Operations Manager</h3>
                            <p className="mt-2 text-gray-700 text-left">
                                Anchit Khanna brings over a decade of experience in building scalable AI-driven architectures. At Vodafone, he leads cross-functional teams that design and implement advanced analytics pipelines to support global operations. Anchit has a track record of transforming legacy infrastructures into modern data ecosystems, enabling real-time decision making and customer personalization. His strategic thinking and leadership have consistently driven digital transformation initiatives across telecom and tech sectors.
                            </p>
                        </div>
                    </div>

                    {/* Tanvi Samel */}
                    <div className="flex flex-col md:flex-row items-start gap-4">
                        <img
                            className="w-full md:w-[20vw] h-[20rem] object-cover rounded-md"
                            src={tanvi}
                            alt="Tanvi Samel"
                        />
                        <div className="md:px-12 mt-4 md:mt-0">
                            <h1 className="text-2xl font-semibold text-left">Tanvi Samel</h1>
                            <h3 className="text-xl text-gray-600 text-left">Product Manager – Workday | Process Excellence Lead</h3>
                            <p className="mt-2 text-gray-700 text-left">
                                Tanvi Samel is an expert in driving large-scale digital transformation initiatives through efficient project governance and change management. With certifications in Agile, Workday, and PMP, she has led global ERP implementations, orchestrated stakeholder communications, and ensured seamless product rollouts. Tanvi's approach to team leadership, budget optimization, and business alignment has consistently yielded accelerated timelines and high client satisfaction. Her meticulous attention to detail and collaborative spirit make her a linchpin in complex enterprise programs.
                            </p>
                        </div>
                    </div>

                    {/* Kushal Khanna */}
                    <div className="flex flex-col md:flex-row items-start gap-4">
                        <img
                            className="w-full md:w-[20vw] h-[20rem] object-cover rounded-md"
                            src={kushal}
                            alt="Kushal Khanna"
                        />
                        <div className="md:px-12 mt-4 md:mt-0">
                            <h1 className="text-2xl font-semibold text-left">Kushal Khanna</h1>
                            <h3 className="text-xl text-gray-600 text-left">Software Engineer – IBM | Full-Stack & Cloud Innovator</h3>
                            <p className="mt-2 text-gray-700 text-left">
                                Kushal Khanna is a cloud-native software engineer with deep expertise in microservices architecture, DevOps pipelines, and frontend scalability. At IBM, he develops mission-critical backend services while also contributing to user-friendly UI frameworks. Kushal's passion for technology extends into open-source contributions, mentoring junior developers, and driving automation strategies that reduce deployment cycles and increase code reliability. His balanced proficiency across the tech stack ensures efficient and elegant software delivery.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Core Values */}
                <div className="mt-12 px-2 md:px-0">
                    <h2 className="text-3xl font-bold text-center mb-6">Our Core Values</h2>
                    <div className="grid md:grid-cols-3 gap-8 text-left">
                        <div className="bg-white p-6 rounded-lg shadow-md border">
                            <h3 className="text-xl font-semibold mb-2 text-blue-700">Integrity</h3>
                            <p className="text-gray-700">We believe in transparency, honesty, and building trust through every action and decision.</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md border">
                            <h3 className="text-xl font-semibold mb-2 text-green-700">Innovation</h3>
                            <p className="text-gray-700">We constantly explore new technologies and ideas to solve real-world business problems.</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md border">
                            <h3 className="text-xl font-semibold mb-2 text-purple-700">Collaboration</h3>
                            <p className="text-gray-700">We succeed as a team, valuing each individual's contribution in a diverse, inclusive environment.</p>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Contact Form */}
            <Contact />
           
        </div>
    );
};

export default About;
